import { dew as _transactionDew } from "../../errors/transaction.js";
import { dew as _sliceDew } from "../data/slice.js";
import { dew as _fromHexDew } from "../encoding/fromHex.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getSerializedTransactionType = void 0;
  const transaction_js_1 = _transactionDew();
  const slice_js_1 = _sliceDew();
  const fromHex_js_1 = _fromHexDew();
  function getSerializedTransactionType(serializedTransaction) {
    const serializedType = (0, slice_js_1.sliceHex)(serializedTransaction, 0, 1);
    if (serializedType === "0x02") return "eip1559";
    if (serializedType === "0x01") return "eip2930";
    if (serializedType !== "0x" && (0, fromHex_js_1.hexToNumber)(serializedType) >= 192) return "legacy";
    throw new transaction_js_1.InvalidSerializedTransactionTypeError({
      serializedType
    });
  }
  exports.getSerializedTransactionType = getSerializedTransactionType;
  //# sourceMappingURL=getSerializedTransactionType.js.map
  return exports;
}